export class MagensaSettings {
    url: string;
    processorName: string;
    customerName: string;
    customerCode: string;
    username: string;
    password: string;
    merchantProcessor: string;
    transactionProcessingServiceName: string;
}
